export default "__VITE_ASSET__DDbpS1K___"